<template>
	<div class="pb-60">
		<el-row :gutter="20" class="p-10">
			<el-col :span="8" v-for="(item,index) in courseList" :key="index">
				<div class="flex align-c justify-c">
					<el-image class="course-img"
						:src="item.img"></el-image>
				</div>
			</el-col>
		</el-row>
		<div class="look-more flex align-c justify-c">查看更多</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				courseList:[
					{img:require('@/assets/images/index/course1.png')},
					{img:require('@/assets/images/index/course2.png')},
					{img:require('@/assets/images/index/course3.png')},
					{img:require('@/assets/images/index/course4.png')},
					{img:require('@/assets/images/index/course5.png')},
					{img:require('@/assets/images/index/course6.png')},
					{img:require('@/assets/images/index/course7.png')},
					{img:require('@/assets/images/index/course8.png')},
					{img:require('@/assets/images/index/course9.png')},
				],
			}
		},
		props:{
			
		},
		methods:{
			
		}
	}
</script>

<style>
	.p-10{
		padding: 0 10px;
		width: 1280px;
	}
	.course-img{
		width: 400px;
		height: 224px;
		margin-bottom: 20px;
	}
	.pb-60{
		padding-bottom: 60px;
	}
	.look-more{
		width: 200px;
		height: 46px;
		border-radius: 8px;
		background: rgba(22, 155, 213, .1);
		margin: auto;
		margin-top: 6px;
		color: #169BD5;
		font-size: 13px;
	}
</style>